var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeafOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9035 16.112C35.7378 22.9198 32.0396 30.7174 30.2509 33.7591C29.9886 34.1845 29.6362 34.5476 29.2188 34.8229C28.8011 35.098 28.3285 35.2788 27.8337 35.3522C24.3288 35.9558 15.6029 36.6319 10.9137 29.824C6.29692 23.4026 6.49029 12.1046 6.90121 6.72119C6.9174 6.32011 7.02873 5.9286 7.22607 5.57889C7.42341 5.22919 7.70106 4.9313 8.0362 4.70972C8.37134 4.48815 8.75436 4.34924 9.15377 4.30442C9.55317 4.25961 9.95754 4.31017 10.3335 4.45194C15.5304 5.94869 26.3592 9.69052 30.9035 16.112Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6119 13.8669C20.1485 20.3831 25.0077 27.4443 29.1149 34.9418",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeafOutline);
export default __webpack_public_path__ + "static/media/icon_leaf_outline.94ae0c62abe311824ada47c4c879f49e.svg";
export { ForwardRef as ReactComponent };